import { render, staticRenderFns } from "./AccountNotActivatedInfo.vue?vue&type=template&id=1eefd517&scoped=true"
import script from "./AccountNotActivatedInfo.vue?vue&type=script&lang=ts"
export * from "./AccountNotActivatedInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefd517",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol})
